module.exports = __webpack_public_path__ + "sflyssofe.fb70c8e331.svg";